import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  accessToken: "",
  isAuthenticated: false,
  user: null,
  mode: "light",
  isOpen: false,
  fcmToken: "abc",
  allPermissions: [],
  allAllowedRoutes: [],
};

const authSlice = createSlice({
  name: "authSlice",
  initialState,
  //   reducer needs a map
  reducers: {
    SaveFcmToken(state, action) {
      state.fcmToken = action.payload.fcmToken;
    },
    saveLoginUserData(state, action) {
      state.user = action.payload.user;
      state.isAuthenticated = true;
      state.accessToken = action.payload.token;
    },
    updateUser: (state, action) => {
      state.user = action.payload;
    },
    setAllPermissions: (state, action) => {
      state.allPermissions = action.payload;
    },
    setAllAllowedRoutes: (state, action) => {
      state.allAllowedRoutes = action.payload;
    },
    signOutRequest(state) {
      state.accessToken = "";
      state.isAuthenticated = false;
      state.user = null;
      state.allPermissions = [];
      state.allAllowedRoutes = [];
    },
    ToggleDrawer(state, action) {
      state.isOpen = action.payload;
    },
  },
});

export const {
  SaveFcmToken,
  saveLoginUserData,
  setAllPermissions,
  setAllAllowedRoutes,
  signOutRequest,
  ToggleDrawer,
  updateUser,
} = authSlice.actions;

export default authSlice.reducer;
